import type {CitationTowableChoice, PropertyCitationType} from "../types";
import {normalizeRangeHoursFromApi} from "./citation-range-hours";

export const CITATION_TOWABLE_OPTIONS: {label: string; value: CitationTowableChoice}[] = [
  {label: "Yes", value: "yes"},
  {label: "No", value: "no"},
];

export function normalizeCitationTowableFromApi(value: unknown): CitationTowableChoice {
  if (value === "yes" || value === true) return "yes";
  return "no";
}

/** Pivot `tow_required_on_select`: API may return 0/1, boolean, or yes/no string. */
export function normalizeTowRequiredOnSelectFromApi(value: unknown): CitationTowableChoice {
  if (value === 1 || value === "1" || value === true || value === "yes") return "yes";
  return "no";
}

export function towableChoiceLabel(choice: CitationTowableChoice | undefined): "Yes" | "No" {
  return choice === "yes" ? "Yes" : "No";
}

/** Property citation pivot `status`: 1 = active, 0 = disabled; default active when missing. */
export function normalizePropertyCitationPivotStatus(value: unknown): 0 | 1 {
  if (value === 0 || value === "0" || value === false) return 0;
  return 1;
}

export function propertyCitationPivotStatusLabel(status: 0 | 1 | undefined): "Active" | "Disabled" {
  return status === 0 ? "Disabled" : "Active";
}

/** Whether this property citation row is active for issuance (`status` 1 or omitted). */
export function isPropertyCitationPivotActive(ct: Pick<PropertyCitationType, "status">): boolean {
  return (ct.status ?? 1) === 1;
}

/** API `can_be_deleted`: 0 = delete disabled in UI; missing defaults to deletable. */
export function normalizePropertyCitationCanBeDeleted(value: unknown): 0 | 1 {
  if (value === 0 || value === "0" || value === false) return 0;
  return 1;
}

export function isPropertyCitationTypeDeletable(ct: Pick<PropertyCitationType, "can_be_deleted">): boolean {
  return normalizePropertyCitationCanBeDeleted(ct.can_be_deleted) === 1;
}

/** Maps API booleans (or legacy strings) to yes/no for form state. */
export function mapPropertyCitationTypesTowableFromApi(
  types: PropertyCitationType[] | undefined,
): PropertyCitationType[] {
  if (!types?.length) return [];
  return types.map((ct) => ({
    ...ct,
    towable: normalizeCitationTowableFromApi((ct as {towable?: unknown}).towable),
    tow_required_on_select: normalizeTowRequiredOnSelectFromApi(
      (ct as {tow_required_on_select?: unknown}).tow_required_on_select,
    ),
    range_hours: normalizeRangeHoursFromApi((ct as {range_hours?: unknown}).range_hours),
    status: normalizePropertyCitationPivotStatus((ct as {status?: unknown}).status),
    can_be_deleted: normalizePropertyCitationCanBeDeleted(
      (ct as {can_be_deleted?: unknown}).can_be_deleted,
    ),
  }));
}
